import script from "./IntroducePage.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroducePage.vue?vue&type=script&setup=true&lang=js"

import "./IntroducePage.vue?vue&type=style&index=0&id=3510c505&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3510c505"]])

export default __exports__